export function Type({ row }) {
  const quizz = row;

  switch(quizz.type){
    case 'cash':
      return 'Cash';
    case 'tourney':
      return 'Tourn';
    default:
      return 'Other';
  }
}
